import { Slider } from "./Slider";
import { SliderElement } from "./SliderElement";
import { SliderEvents } from "./sliderEvents";

window.o_global.pali.slider = Slider;

window.o_global.eventLoader.onReady(130, () =>
  window.o_global.pali.slider.init(SliderElement, Slider, "body")
);

window.o_global.events<SliderEvents>().on("assets.slider.init", (selector?: string) => {
  window.o_global.pali.slider.init(SliderElement, Slider, selector);
});

export type { Slider, SliderElement, SliderEvents };
